import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import SchluesselbestellungApp from "../components/contact/SchluesselbestellungApp.vue";

export default function() {
  const element = document.querySelector("#vue-schluesselbestellung");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      let vueArgs = {};

      vueArgs = {...vueArgs, ...{
        el: element,

        components: {
          SchluesselbestellungApp
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(SchluesselbestellungApp)
      }};

      new Vue(vueArgs)
    });
  }
}
